<input #fileUploader type="file" hidden (change)="UploadFile(fileUploader)" />
<div
  class="center"
  >
  @if (!fileName) {
    <button
      (click)="fileUploader.click()"
      class="btn btn-default btn-sm ml-2"
      >
      Upload
    </button>
  }
  @if (fileName) {
    <button
      (click)="fileUploader.click()"
      class="btn btn-default btn-sm ml-2"
      >
      Upload New
    </button>
  }
  <div class="stack">
    @if (fileName) {
      <span container="body">
        {{ createSubstring(fileName) }}
      </span>
    }
    @if (fileName) {
      <button
        class="btn btn-save btn-sm ml-2"
        (click)="SubmitFile()"
        >
        Submit
      </button>
    }
    @if (fileName && deleteUrl) {
      <button
        class="btn btn-cancel btn-sm ml-2"
        (click)="RemoveFile()"
        >
        Remove
      </button>
    }
  </div>
</div>
